function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#EUR_svg__clip0_1_63)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 29.088c8.284 0 15-6.447 15-14.4S23.284.288 15 .288c-8.284 0-15 6.447-15 14.4s6.716 14.4 15 14.4z",
  fill: "#2953E7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 18.132c-.55.372-1.225.576-2.025.576-1.712 0-2.925-.924-3.425-2.376h4.675v-1.176h-4.912c-.013-.144-.013-.288-.013-.444 0-.168.013-.348.025-.504h4.9v-1.176h-4.65c.5-1.428 1.675-2.376 3.388-2.376.737 0 1.362.18 1.887.492l.713-2.136c-.788-.372-1.713-.588-2.775-.588-3.1 0-5.288 1.884-5.938 4.608H9v1.176h1.15a4.274 4.274 0 00-.037.564c0 .132.012.252.012.384H9v1.176h1.288c.562 2.676 2.612 4.608 5.775 4.608 1.162 0 2.2-.24 3.087-.684l-.65-2.124z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "EUR_svg__clip0_1_63"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgEur(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "b9f275f136befcf5c369b6ba521de542.svg";
export { SvgEur as ReactComponent };